import { valid } from "semver";
import { isValidDate } from "../ValidationFunctions";

export const reducerActions = {
    ON_CHANGE_DROPDOWN: 'ON_CHANGE_DROPDOWN',
    ON_BLUR_DROPDOWN: 'ON_BLUR_DROPDOWN',


    FORM_DEFINITION_RECEIVED: 'FORM_DEFINITION_RECEIVED',
    FORM_SRC_RECEIVED: 'FORM_SRC_RECEIVED',   
    SET_TOUCHED: 'SET_TOUCHED',
    ON_CHANGE_TEXTBOX: 'ON_CHANGE_TEXTBOX',
    ON_CHANGE_TEXTAREA: 'ON_CHANGE_TEXTAREA',    
    ON_CHANGE_TYPEAHEAD: 'ON_CHANGE_TYPEAHEAD',
    ON_CHANGE_CHECKBOX: 'ON_CHANGE_CHECKBOX',    
    ON_CHANGE_DATE_MM_DD_YYYY: 'ON_CHANGE_DATE_MM_DD_YYYY',
    SET_SAVE_COPY: 'SET_SAVE_COPY',      
    UPDATE_FIELD: 'UPDATE_FIELD',
    SUBMIT_FINISHED: 'SUBMIT_FINISHED',   
    SUBMIT_FAILED: 'SUBMIT_FAILED',   
    RESET_FORM: 'RESET_FORM',
    ACTIVATE_PAGE: 'ACTIVATE_PAGE',   
    GO_TO_NEXT_PAGE: 'GO_TO_NEXT_PAGE',
    GO_TO_PREVIOUS_PAGE: 'GO_TO_PREVIOUS_PAGE',    
    SUBMIT_FORM: 'SUBMIT_FORM',
    ON_CHANGE_CHECKBOX: 'ON_CHANGE_CHECKBOX',
    ON_BLUR_TEXTBOX: 'ON_BLUR_TEXTBOX',
    ON_BLUR_TYPEAHEAD: 'ON_BLUR_TYPEAHEAD',
    ON_BLUR_CHECKBOX: 'ON_BLUR_CHECKBOX',
    ON_BLUR_DATE_MM_DD_YYYY: 'ON_BLUR_DATE_MM_DD_YYYY',
    ON_BLUR_TEXTAREA: 'ON_BLUR_TEXTAREA',
    SET_API_BUSY: 'SET_API_BUSY',
    PDF_GENERATED: 'PDF_GENERATED',
}

let formObject = {};

export function formReducer(state, action) {

    let pages = [];
    let firstPageKey = null;
    let lastPageKey = null;
    let currentPage = null;        
    let currentIndex = null;
    let nextPageKey = null;
    let previousPageKey = null;
    let newState = null;
    let newFormState = null;

  switch (action.type) {

    case reducerActions.PDF_GENERATED:
         var {value} = action.payload
        return {
            ...state,
            pdfBlob: value,
        };
    case reducerActions.SET_API_BUSY:
        var {value} = action.payload
        return {
            ...state,
            apiBusy: value,
        };

    case reducerActions.FORM_SRC_RECEIVED:
            return {
                ...state,
                formLoaded: true,                
    };
   
    case reducerActions.FORM_DEFINITION_RECEIVED:
        pages = Object.entries(action.payload.fields)
            .filter(([_, field]) => field.fieldType === "formPage")
            .map(([key]) => key);

        firstPageKey = pages[0] || null;
        lastPageKey = pages[pages.length - 1] || null;
        
        formObject = window[action.formObjectName];
        window.formObjectName = action.formObjectName;
        return {
            ...state,  
            formObjectName: action.formObjectName,         
            formState: action.payload,               
            formLists: action.payload.lists || {},
            apiBusy: false, 
            activePage: firstPageKey || '',
            firstPage: firstPageKey || '',
            lastPage: lastPageKey || '',
            numberOfPages: pages.length,
        };

    case reducerActions.ON_CHANGE_TEXTBOX:   
    case reducerActions.ON_CHANGE_TEXTAREA:
        newFormState = JSON.parse(JSON.stringify(state.formState));
        var {key,value} = action.payload;
        var changedTextArea = newFormState.fields[key];
        changedTextArea.fieldValue = value;
      
        var validationResult = validateTextBox(changedTextArea, newFormState);       
        
        let onChangeHandler1 = formObject.fields[key].onChange;
        if (typeof onChangeHandler1 === 'function') {
            newFormState = onChangeHandler1(newFormState.fields[key], newFormState); 
        }

         return {
            ...state,
            formState: newFormState
        };
    
    case reducerActions.ON_CHANGE_DROPDOWN:
        newFormState = JSON.parse(JSON.stringify(state.formState));
        var {key,value} = action.payload;
        let dropdown = newFormState.fields[key];
        dropdown.fieldValue = value;
      
        validateDropdown(dropdown, newFormState);       
        
        let onChangeHandler2 = formObject.fields[key].onChange;
        if (typeof onChangeHandler2 === 'function') {
            newFormState = onChangeHandler2(newFormState.fields[key], newFormState); 
        }

         return {
            ...state,
            formState: newFormState
        };    
    case reducerActions.ON_BLUR_DROPDOWN: 
        newFormState = JSON.parse(JSON.stringify(state.formState));        
        let blurredDropdown = newFormState.fields[action.payload.key];               
        validateDropdown(blurredDropdown, newFormState);       
        return {
            ...state,
            formState: newFormState,
        };
    case reducerActions.ON_BLUR_TEXTBOX:
    case reducerActions.ON_BLUR_TEXTAREA: 
        newFormState = JSON.parse(JSON.stringify(state.formState));        
        var blurredTextBox = newFormState.fields[action.payload.key];               
        var validationResult = validateTextBox(blurredTextBox, newFormState);       
        return {
            ...state,
            formState: newFormState,
        };
    
    case reducerActions.ON_BLUR_TYPEAHEAD: 
        newFormState = JSON.parse(JSON.stringify(state.formState));        
        var blurredTypeAhead = newFormState.fields[action.payload.key];               
        var validationResult = validateTypeAhead(blurredTypeAhead, newFormState);       
        return {
            ...state,
            formState: newFormState,
        };

    case reducerActions.ON_CHANGE_TYPEAHEAD:
        newFormState = JSON.parse(JSON.stringify(state.formState));
        var {key,value} = action.payload;
        var changedTypeAhead = newFormState.fields[key];
        changedTypeAhead.fieldValue = value;
      
         var validationResult = validateTypeAhead(changedTypeAhead, newFormState);       
        
         let onChangeTypeAheadHandler = formObject.fields[key].onChange;
         if (typeof onChangeTypeAheadHandler === 'function') {
             newFormState = onChangeTypeAheadHandler(newFormState.fields[key], newFormState); 
         }

         return {
            ...state,
            formState: newFormState
        };
  
    case reducerActions.SUBMIT_FINISHED:
        return {    
            ...state,
            submitFinished: true,
            showConfirmation: true,
            apiBusy: false,
            validated: false,
        };
     case reducerActions.SUBMIT_FAILED:
        newFormState = JSON.parse(JSON.stringify(state.formState));   
        newFormState.fields['submitResult']={summaryError:"An error occurred submitting the form. Please try again later."};

        return {    
            ...state,
            formState: newFormState,
            submitFinished: false,
            readyToSubmit: false,
            showConfirmation: false,
            apiBusy: false,
            validated: false,
        };
    case reducerActions.RESET_FORM:  
       
        return {
            ...state,
            formState: {
                ...formObject,
                fields: JSON.parse(JSON.stringify(formObject.fields)),
            },
            validated: false,
            apiBusy: false,
            submitFinished: false,
        };

    case reducerActions.SET_TOUCHED:
        var {key} = action.payload;
        return {    
            ...state,
            formState: {
                ...state.formState,
                fields: {
                    ...state.formState.fields,
                    [key]: {
                        ...state.formState.fields[key],
                        isTouched: true,
                    },
                },
            },
        };
    
    case reducerActions.SET_SAVE_COPY:
        newFormState = JSON.parse(JSON.stringify(state.formState));
        newFormState.saveCopy = action.payload;
        return {
            ...state,
            formState: newFormState
        };

    case reducerActions.ACTIVATE_PAGE:
        return {
            ...state,
            activePage: action.payload.pageKey,
        };
       
    case reducerActions.GO_TO_NEXT_PAGE:
        newState = JSON.parse(JSON.stringify(state));
        pages = Object.keys(state.formState.fields).filter(key => state.formState.fields[key].fieldType === "formPage");
        currentIndex = pages.indexOf(state.activePage);
        nextPageKey = pages[currentIndex + 1] || null;

        var validationResult = validatePage(state.activePage, newState.formState);
        if (validationResult.isValid) {
            if(state.activePage === state.lastPage) {
                //if on the last page, submit
            }
            else{
                 //if the current page is valid, go to the next page
                 newState.activePage = nextPageKey;
            }
            //if the current page is valid, go to the next page
            if(state.activePage === state.lastPage) {
                //submit
            }   
            requestAnimationFrame(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            });
        }
        else{
            requestAnimationFrame(() => {
                window.scrollTo({ top: document.body.scrollHeight,  behavior: "smooth"});                
            });         
        }      
      
        return newState;

    case reducerActions.GO_TO_PREVIOUS_PAGE:
        currentPage = state.activePage; 
        pages = Object.keys(state.formState.fields).filter(key => state.formState.fields[key].fieldType === "formPage");
        currentIndex = pages.indexOf(currentPage);
        previousPageKey = pages[currentIndex - 1] || null;
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });  
        return {
            ...state,
            activePage: previousPageKey || '',
        };

    case reducerActions.ON_CHANGE_CHECKBOX:
      
        newFormState = JSON.parse(JSON.stringify(state.formState));
        var field = newFormState.fields[action.payload.key];
        field.fieldValue = action.payload.value;
            
        const onChangeHandler = formObject.fields[action.payload.key].onChange;
        if (typeof onChangeHandler === 'function') {
            newFormState = onChangeHandler(newFormState.fields[action.payload.key], newFormState); 
        }
      
        var validationResult = validateCheckBox(field, newFormState);  
      
        return {
            ...state,
            formState: newFormState
        };

    case reducerActions.ON_BLUR_CHECKBOX:
       newFormState = JSON.parse(JSON.stringify(state.formState));        
        var field = newFormState.fields[action.payload];               
        var validationResult = validateCheckBox(field, newFormState);       
        return {
            ...state,
            formState: newFormState,
        };
   
    case reducerActions.ON_BLUR_TEXTAREA: 
        newFormState = JSON.parse(JSON.stringify(state.formState));        
        var field = newFormState.fields[action.payload.key];               
        var validationResult = validateTextBox(field, newFormState);       
        return {
            ...state,
            formState: newFormState,
        };
    
    case reducerActions.ON_CHANGE_DATE_MM_DD_YYYY: 
        newFormState = JSON.parse(JSON.stringify(state.formState));
        var {key,value} = action.payload;
        var field = newFormState.fields[key];
        field.fieldValue = value;
      
        var validationResult = validateDate_mm_dd_yyyy(field, newFormState);       
        
        let onChangeDateHandler = formObject.fields[key].onChange;
        if (typeof onChangeDateHandler === 'function') {
            newFormState = onChangeDateHandler(newFormState.fields[key], newFormState); 
        }


         return {
            ...state,
            formState: newFormState
        };
        
    case reducerActions.ON_BLUR_DATE_MM_DD_YYYY:
        newFormState = JSON.parse(JSON.stringify(state.formState));        
        var field = newFormState.fields[action.payload.key];               
        var validationResult = validateDate_mm_dd_yyyy(field, newFormState);       
        return {
            ...state,
            formState: newFormState,
        };

    case reducerActions.SUBMIT_FORM:
        newFormState = JSON.parse(JSON.stringify(state.formState));   
        newFormState.fields['submitResult']={summaryError:""};

        let validateAllFieldsResult = validateAllFields(newFormState);
        if (!validateAllFieldsResult.isValid) {
            // If the form is not valid, set the validation state
            return {
                ...state,
                formState: newFormState,
                apiBusy: false,
                readyToSubmit: false,
            };
        }
        return {
            ...state,
            formState: newFormState,
            apiBusy: true,
            readyToSubmit: true
        };
          
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
}

const validateTextBox = (field, formState) => {
    field.isTouched= true;  
    field.isValid = true;
    if (field.fieldRequired && ( !field.fieldValue || !field.fieldValue.trim())) { 
        field.isValid = false;     
        field.error = "This field is required.";
        field.summaryError = `${field.fieldLabel || field.fieldName} is required.`;
    } else {
        field.error = "";
        field.summaryError = "";
    }    
    
    let customValidation = formObject.fields[`field${field.fieldId}`]?.validation;
    if (typeof customValidation === "function") {
      const customMessage = customValidation(formState);
      if (customMessage?.error) {
        field.error = customMessage.error;
        field.isValid = false;
      }
      if (customMessage?.summaryError) {
        field.summaryError = customMessage.summaryError;
        field.isValid = false;
      }     
    }
    return {isValid : field.isValid};
}

const validateDropdown = (field, formState) => {
    //the same stuff happens for a dropdown as a textbox
    return validateTextBox(field, formState);
}

const validateDate_mm_dd_yyyy = (field, formState) => {
    field.isTouched= true;  
    field.isValid = true;
    field.error = "";
    field.summaryError = "";
    const label = field.fieldLabel?.replace(/:$/, '') || '';
    
    //validatie required
    if (field.fieldRequired && (!field.fieldValue || !field.fieldValue.trim())) {
        field.isValid = false;     
        field.error = "This field is required.";
        field.summaryError = `${label || field.fieldName} is required.`;
    }

    //is an actual date
    if(field.isValid && field.fieldValue) {
        if(!isValidDate(field.fieldValue)) {
            field.isValid = false;
            field.error = "Invalid date.";
            field.summaryError = `${label || field.fieldName} is an invalid date.`;
        }
    }

    //custom validation    
    let customValidation = formObject.fields[`field${field.fieldId}`]?.validation;
    if (field.isValid && typeof customValidation === "function") {
      const customMessage = customValidation(formState);
      if (customMessage?.error) {
        field.error = customMessage.error;
        field.isValid = false;
      }
      if (customMessage?.summaryError) {
        field.summaryError = customMessage.summaryError;
        field.isValid = false;
      }     
    }
    return {isValid : field.isValid};
}

const validateTypeAhead = (field, formState) => {
    field.isTouched= true;  
    field.isValid = true;
    if (field.fieldRequired && (!field.fieldValue  || !field.fieldValue[0] || !field.fieldValue[0].trim())) { 
        field.isValid = false;     
        field.error = "This field is required.";
        field.summaryError = `${field.fieldLabel || field.fieldName} is required.`;
    } else {
        field.error = "";
        field.summaryError = "";
    }    
    
    let customValidation = formObject.fields[`field${field.fieldId}`]?.validation;
    if (field.isValid && typeof customValidation === "function") {
      const customMessage = customValidation(formState);
      if (customMessage?.error) {
        field.error = customMessage.error;
        field.isValid = false;
      }
      if (customMessage?.summaryError) {
        field.summaryError = customMessage.summaryError;
        field.isValid = false;
      }     
    }
    return {isValid : field.isValid};
}

const validateCheckBox = (field, formState) => {
    field.isTouched= true;  
    field.isValid = true;
    if (field.fieldRequired && (!field.fieldValue || !field.fieldValue.trim())) { 
        field.isValid = false;     
        field.error = "This field is required.";
        field.summaryError = `${field.fieldLabel || field.fieldName} is required.`;
    } else {
        field.error = "";
        field.summaryError = "";
    }    
    
    let customValidation = formObject.fields[`field${field.fieldId}`]?.validation;
    if (field.isValid && typeof customValidation === "function") {
      const customMessage = customValidation(formState);
      if (customMessage?.error) {
        field.error = customMessage.error;
        field.isValid = false;
      }
      if (customMessage?.summaryError) {
        field.summaryError = customMessage.summaryError;
        field.isValid = false;
      }     
    }
    return {isValid : field.isValid};
}

const validatePage = (pageKey, formState) => {
    
    const pageFields = Object.values(formState.fields)
        .filter(field => isOnPage( `field${field.fieldId}`, pageKey, formState.fields));
    if (pageFields.length === 0) return {isValid: true};
    
    let isValid = true;

    for (const field of pageFields) {
        if(field.fieldType === "text" || field.fieldType === "textarea"){
            const validationResult = validateTextBox(field, formState);        
            if (!validationResult.isValid) {
                isValid = false;         
            }
        }  
        if(field.fieldType === "checkbox"){
            const validationResult = validateCheckBox(field, formState);        
            if (!validationResult.isValid) {
                isValid = false;         
            }
        }  
        if(field.fieldType === 'dateMMDDYYYY'){
            const validationResult = validateDate_mm_dd_yyyy(field, formState);
            if (!validationResult.isValid) {
                isValid = false;
            }
        }
         if(field.fieldType === 'typeahead'){
            const validationResult = validateTypeAhead(field, formState);
            if (!validationResult.isValid) {
                isValid = false;
            }
        }
         if(field.fieldType === 'dropdown'){
            const validationResult = validateDropdown(field, formState);
            if (!validationResult.isValid) {
                isValid = false;
            }
        }

    }

    return {isValid};                      
}

const validateAllFields = (formState) => {
    const formFields = Object.values(formState.fields);
    if (formFields.length === 0) return {isValid: true};

    let isValid = true;

    for (const field of formFields) {
        
        if(field.fieldType == "text" || field.fieldType == "textarea"){
            const validationResult = validateTextBox(field, formState);        
            if (!validationResult.isValid) {
                isValid = false;         
            }
        }    
        if(field.fieldType == "checkbox"){
            const validationResult = validateCheckBox(field, formState);        
            if (!validationResult.isValid) {
                isValid = false;         
            }
        }  
        if(field.fieldType === 'dateMMDDYYYY'){
            const validationResult = validateDate_mm_dd_yyyy(field, formState);
            if (!validationResult.isValid) {
                isValid = false;
            }
        }    
        if(field.fieldType === 'typeAhead'){
            const validationResult = validateTypeAhead(field, formState);
            if (!validationResult.isValid) {
                isValid = false;
            }
        }    
        if(field.fieldType === 'dropdown'){
            const validationResult = validateDropdown(field, formState);
            if (!validationResult.isValid) {
                isValid = false;
            }
        }    
    }
    return {isValid};   
}

// given a page
// return a list of all control keys nested within the page
const findDescendants = (pageId, formFileds )=> {
  const descendants = [];

  function recurse(containerId) {
    for (const [key, value] of Object.entries(formFileds)) {
      if (value.containerId === containerId) {
        descendants.push(key);
        recurse(key); // go deeper
      }
    }
  }

  recurse(pageId);
  return descendants;

};

const isOnPage = (controlKey, pageKey, formFileds )=> {

    let isOnPage = false;
    const pageDecendants =  findDescendants (pageKey, formFileds );
    isOnPage = pageDecendants.includes(controlKey); // true
    return isOnPage;

};